module.exports = __webpack_public_path__ + "static/media/oblong_g.b8ddbdd1.svg";